import React, { useMemo, useState, useEffect } from 'react';
import Navigation from '../AdminLayout/Navigation';
import NavBar from '../AdminLayout/NavBar';
import { COUNTRIES } from 'src/config/constant';

const CampaignGenarationContext = React.createContext();
export const useCampaignGenarationContext = () => React.useContext(CampaignGenarationContext);

const CampaignGenarionLayout = ({ children }) => {
const [region, setRegion] = useState(() => {
  const savedRegion = localStorage.getItem('campaign_region');
  if (savedRegion) {
    try {
      return JSON.parse(savedRegion);
    } catch (error) {
      console.error('Error parsing saved region:', error);
      return COUNTRIES?.[0];
    }
  }
  return COUNTRIES?.[0];
});

const [currentPath, setCurrentPath] = useState(window.location.pathname)

useEffect(() => {
  if (region) {
    localStorage.setItem('campaign_region', JSON.stringify(region));
  }
}, [region]);

useEffect(() => {
  setCurrentPath(window.location.pathname)
}, [window.location.pathname])

const isLandingPage = useMemo(() => currentPath.includes('/manual-keyword-targeting-campaign-generation') || currentPath.includes('/manual-product-targeting-campaign-generation'), [currentPath])
const contextValue = React.useMemo(() => ({
  region, 
  setRegion,
  isLandingPage
}), [
  region, 
  setRegion,
  isLandingPage
])

  return (
    <CampaignGenarationContext.Provider value={contextValue}>
      <Navigation />
      <NavBar/>
      <div className="pcoded-main-container">
        <div className="pcoded-content">
          <div className="pcoded-inner-content">
            <div className="main-body">
              <div className="page-wrapper">
                {children}
              </div>
            </div>
          </div>
        </div>
      </div>
    </CampaignGenarationContext.Provider>
  );
};

export default CampaignGenarionLayout;